import React from 'react';
import Title from './Title';
import Snippet from './Snippet';
import Preview from './Preview';


const Jira = ({ item, isPreview }: any) => {

  if (isPreview) {
    return <Preview item={item} />
  }
  return (
    <>
      <Title item={item} />
      <Snippet item={item} />
    </>
  )
}

export default Jira;